import { render, staticRenderFns } from "./SlideSun.vue?vue&type=template&id=1f496ed0&scoped=true&"
import script from "./SlideSun.vue?vue&type=script&lang=js&"
export * from "./SlideSun.vue?vue&type=script&lang=js&"
import style0 from "./SlideSun.vue?vue&type=style&index=0&id=1f496ed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f496ed0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiClock: require('/opt/build/repo/components/UiClock.vue').default,Typography: require('/opt/build/repo/components/Typography.vue').default})
